import { render, staticRenderFns } from "./NumberChip.vue?vue&type=template&id=49320f04&scoped=true&"
import script from "./NumberChip.vue?vue&type=script&lang=js&"
export * from "./NumberChip.vue?vue&type=script&lang=js&"
import style0 from "./NumberChip.vue?vue&type=style&index=0&id=49320f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49320f04",
  null
  
)

export default component.exports